'use client';
import { useEffect } from 'react';
import { createClient } from '@/lib/supabase/client';

/** Injects a script tag into <head> so popunder scripts execute globally */
function injectScript(html: string) {
  const temp = document.createElement('div');
  temp.innerHTML = html;

  Array.from(temp.querySelectorAll('script')).forEach((origScript) => {
    const script = document.createElement('script');
    if (origScript.src) {
      script.src = origScript.src;
      script.async = true;
    } else {
      script.textContent = origScript.textContent;
    }
    Array.from(origScript.attributes).forEach((attr) => {
      if (attr.name !== 'src') script.setAttribute(attr.name, attr.value);
    });
    document.head.appendChild(script);
  });

  // Also handle non-script content (e.g. noscript, inline HTML)
  Array.from(temp.childNodes).forEach((node) => {
    if (node.nodeName !== 'SCRIPT') {
      document.body.appendChild(node.cloneNode(true));
    }
  });
}

export default function PopunderAd() {
  const supabase = createClient();

  useEffect(() => {
    let injected = false;

    async function fetchAndInject() {
      try {
        const { data, error } = await supabase
          .from('advertisements')
          .select('id, ad_type, custom_html')
          .eq('placement', 'popunder')
          .eq('is_active', true)
          .limit(1)
          .maybeSingle();

        if (error || !data || !data.custom_html) return;
        if (injected) return;
        injected = true;
        injectScript(data.custom_html);
      } catch {
        // Silently fail
      }
    }

    fetchAndInject();
  }, []);

  // Renders nothing — popunder scripts run in the background
  return null;
}
